<template>
  <div>
    <a
      @click.stop.prevent="detailFun"
      style="text-decoration: none; cursor: pointer"
      >{{ $ts("DeployManagement.detail") }}</a
    ><span style="margin-left: 15px"></span>
  </div>
</template>

<script>
import { EventBus } from "../../../../plugins/eventBus";
import i18n from "../../../../plugins/i18n.js";

export default {
  name: "RunDetailTemplate",
  components: {},
  data() {
    return {
      data: {},
    };
  },
  methods: {
    $ts(args) {
      const mes = args.split(".");
      const result =
        mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]
          ? i18n.messages[i18n.locale][mes[0]][mes[1]]
          : args;
      return result;
    },
    detailFun() {
      EventBus.$emit("openQueryRunVersion", this.data);
    },
  },
};
</script>

<style scoped>
</style>
